export { default as WizardContainerTemplate } from './WizardContainerTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/index.js